import React from 'react';
import i18n from '../../../i18n/i18n';

import LazyImage from '../../../components/LazyImage';

import lowVisibilityImg from "../../../images/bulkListing/low-visibility.png";
import troublesomeApplicationImg from "../../../images/bulkListing/troublesome-application.png";
import limitedChannelsImg from "../../../images/bulkListing/limited-channels.png";
import lowUtilizationImg from "../../../images/bulkListing/low-utilization.png";

const problemsList = [
  {
    image: lowVisibilityImg,
    title: i18n.t("bulkListing.problemsBanner.lowVisibility"),
    alt: "low-visibility-img"
  },
  {
    image: troublesomeApplicationImg,
    title: i18n.t("bulkListing.problemsBanner.troublesomeApp"),
    alt: "troublesome-application-img"
  },
  {
    image: limitedChannelsImg,
    title: i18n.t("bulkListing.problemsBanner.limitedChannels"),
    alt: "limited-channels-img"
  },
  {
    image: lowUtilizationImg,
    title: i18n.t("bulkListing.problemsBanner.lowUtilization"),
    alt: "low-utilization-img"
  },
];

const ProblemsBanner = () => {
  return (
    <div className="w-full bg-[#F7F7F7] p-[25px] md:py-[50px] md:px-[70px] lg:py-[30px] lg:px-[100px] xl:px-[200px] 2xl:px-[300px]">
      <div className="flex flex-col items-center my-[15px]">
        <div className="text-[15px] text-black font-bold text-center md:text-[20px]">{i18n.t("bulkListing.problemsBanner.title")}</div>
        <div className="flex flex-row flex-wrap justify-center mt-[15px]">
          {problemsList.map((problem, index) => (
            <div className="flex flex-col bg-white w-[220px] items-center m-[10px] rounded-[8px] shadow-[1px_1px_5px_1px_rgba(0,0,0,0.2)]" key={`problem-${index}`}>
              <LazyImage className="w-[100%] object-cover" src={problem.image} alt={problem.alt} />
              <div className="flex h-[65px] items-center justify-center">
                <div className="mx-[20px] text-black text-[11px] font-medium text-center md:text-[12px]">{problem.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProblemsBanner;